module.exports = __webpack_public_path__ + "static/media/profile2.c3376c11.jpg";